// Numeros para os graficos e os cartoes, no locale da lingua do backoffice. Os Intl.NumberFormat sao
// caros de construir e ficam em cache por lingua e por forma, como no utils/datetime.js.
export const LOCALES = { pt: "pt-PT", en: "en-GB" };

const formatters = new Map();

const formatter = (language, kind, options) => {
  const key = `${language}:${kind}`;
  if (!formatters.has(key)) formatters.set(key, new Intl.NumberFormat(LOCALES[language] || language, options));
  return formatters.get(key);
};

export const formatCount = (value, language) => formatter(language, "count", { maximumFractionDigits: 0 }).format(value);

// Os eixos: 1200 e "1,2 mil" ou "1.2K".
export const formatCompact = (value, language) =>
  formatter(language, "compact", { notation: "compact", maximumFractionDigits: 1 }).format(value);

// Uma casa decimal, como o backend calcula as taxas.
export const formatDecimal = (value, language) =>
  formatter(language, "decimal", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value);

export const formatPercent = (value, language) => `${formatDecimal(value, language)}%`;

// A parte de um total, para a legenda e o nome de cada segmento: "21 (55,3%)". As taxas do contrato
// vem feitas do backend, e a pagina so calcula a parte de um total que ja tem na mao: esta, e a
// passagem entre dois degraus do funil ("Global Constraints" do plano da entrega 6).
export const formatShare = (value, total, language) =>
  total ? `${formatCount(value, language)} (${formatPercent((100 * value) / total, language)})` : formatCount(value, language);

// A mesma parte em percentagem, como numero com uma casa no maximo, para o ficheiro de "Descarregar esta
// tabela", que o escreve sem formatacao (55.3, como as taxas do CSAT). Arredonda-a o Intl, como no ecra, para
// o ficheiro dizer o que a pagina diz: o `toFixed` arredonda o double exato, e em 23 de 2000 (1,1499... no
// double) dava 1.1 onde o ecra mostra 1,2%.
const plainDecimal = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1, useGrouping: false });
export const sharePercent = (value, total) => Number(plainDecimal.format((100 * value) / total));

// Um numero com casas fixas: a taxa de abertura em percentagem leva duas (1,03%).
export const formatFixed = (value, digits, language) =>
  formatter(language, `fixed${digits}`, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);
